import { Link, NavLink } from "react-router-dom";
import { Phone, Menu, X, MessageSquare } from "lucide-react";
import { BrandLogo } from "@/components/BrandLogo";
import { SMS_HREF } from "@/components/Layout";

export const NAV = [
  { to: "/services", label: "Services" },
  { to: "/gallery", label: "Gallery" },
  { to: "/ask", label: "Ask Dr.Gadget" },
  { to: "/membership", label: "Membership" },
  { to: "/about", label: "About" },
];

export function SiteHeader({ logo, open, onToggle }) {
  return (
    <header className="sticky top-0 z-40 backdrop-blur-xl bg-[#0B1120]/80 border-b border-slate-800">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 py-3 flex items-center justify-between gap-4">
        <Link to="/" className="flex items-center gap-3 shrink-0" data-testid="brand-link">
          {logo ? <img src={logo} alt="Dr.Gadget" className="h-10 max-w-[180px] object-contain rounded-md" data-testid="brand-logo-img" /> : <BrandLogo />}
          <div className="hidden sm:block text-[10px] uppercase tracking-[0.22em] text-cyan-400 font-mono border-l border-slate-700 pl-3">Tech Support<br />& Consultations</div>
        </Link>
        <nav className="hidden md:flex items-center gap-6">
          {NAV.map((n) => (
            <NavLink key={n.to} to={n.to} data-testid={`nav-${n.to.replace("/", "")}`}
              className={({ isActive }) => `text-sm font-medium transition-colors ${isActive ? "text-cyan-400" : "text-slate-300 hover:text-white"}`}>
              {n.label}
            </NavLink>
          ))}
        </nav>
        <div className="hidden md:flex items-center gap-2">
          <a href="tel:+13104220669" className="dg-btn-ghost rounded-full px-4 py-2 text-sm flex items-center gap-2" data-testid="header-call-btn">
            <Phone className="w-4 h-4" /> 310-422-0669
          </a>
          <Link to="/book" className="dg-btn-primary rounded-full px-5 py-2 text-sm" data-testid="header-book-btn">
            Book a Session
          </Link>
        </div>
        <button className="md:hidden p-2.5 -mr-1 rounded-md border border-slate-800 text-slate-300 min-w-[44px] min-h-[44px] grid place-items-center" aria-label="Toggle menu" aria-expanded={open} onClick={onToggle} data-testid="mobile-menu-toggle">
          {open ? <X className="w-5 h-5" /> : <Menu className="w-5 h-5" />}
        </button>
      </div>
      {open && (
        <div className="md:hidden border-t border-slate-800 bg-[#0B1120]/95 max-h-[calc(100vh-64px)] overflow-y-auto" data-testid="mobile-menu">
          <div className="px-4 py-3 flex flex-col">
            {NAV.map((n) => (
              <NavLink key={n.to} to={n.to} data-testid={`mnav-${n.to.replace("/", "")}`}
                className={({ isActive }) => `py-3 text-base border-b border-slate-800/70 ${isActive ? "text-cyan-400" : "text-slate-200"}`}>{n.label}</NavLink>
            ))}
            <NavLink to="/gift" className="py-3 text-base border-b border-slate-800/70 text-slate-200" data-testid="mnav-gift">Gift a session</NavLink>
            <NavLink to="/flyers" className="py-3 text-base border-b border-slate-800/70 text-slate-200" data-testid="mnav-flyers">Flyers</NavLink>
            <div className="grid grid-cols-2 gap-2 mt-3">
              <a href="tel:+13104220669" className="dg-btn-ghost rounded-full py-3 text-sm flex items-center justify-center gap-2" data-testid="mnav-call">
                <Phone className="w-4 h-4" /> Call David
              </a>
              <a href={SMS_HREF} className="dg-btn-ghost rounded-full py-3 text-sm flex items-center justify-center gap-2" data-testid="mnav-text">
                <MessageSquare className="w-4 h-4" /> Text David
              </a>
              <Link to="/book" className="dg-btn-primary rounded-full py-3 text-sm text-center flex items-center justify-center col-span-2" data-testid="mnav-book">
                Book a Session
              </Link>
            </div>
          </div>
        </div>
      )}
    </header>
  );
}
